function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3465",
  "data-name": "Grupo 3465",
  transform: "translate(-2051.345 -1490.845)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3464",
  "data-name": "Grupo 3464",
  transform: "translate(2051.345 1490.845)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_122",
  "data-name": "Caminho 122",
  d: "M2100.376,1788.218a9.382,9.382,0,0,1-3.866-7.589h-.007a22.579,22.579,0,1,0-22.579,22.578h0a9.4,9.4,0,0,1,7.6,3.87,13.5,13.5,0,1,0,18.855-18.859Z",
  transform: "translate(-2051.345 -1711.455)",
  fill: "#f57900"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_123",
  "data-name": "Caminho 123",
  d: "M2487.225,1640.873a20.061,20.061,0,0,0-8.277,16.236h0a48.341,48.341,0,1,1-48.341-48.338h0a20.056,20.056,0,0,0,16.235-8.28,28.924,28.924,0,1,1,40.383,40.383Z",
  transform: "translate(-2324.559 -1571.471)",
  fill: "#fee602"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_124",
  "data-name": "Caminho 124",
  d: "M2257.877,1857.347a27.022,27.022,0,1,0,27.036,27.022A27.059,27.059,0,0,0,2257.877,1857.347Zm0,40.533a13.511,13.511,0,1,1,13.518-13.511A13.513,13.513,0,0,1,2257.877,1897.881Z",
  transform: "translate(-2199.54 -1793.435)",
  fill: "#3a32a7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_125",
  "data-name": "Caminho 125",
  d: "M2596.982,1597.077a24.8,24.8,0,1,0,24.8,24.8A24.817,24.817,0,0,0,2596.982,1597.077Zm0,37.2a12.4,12.4,0,1,1,12.393-12.4A12.409,12.409,0,0,1,2596.982,1634.28Z",
  transform: "translate(-2481.348 -1578.552)",
  fill: "#3a32a7"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3449",
  "data-name": "Grupo 3449",
  transform: "translate(38.874 39.46)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_126",
  "data-name": "Caminho 126",
  d: "M2356.129,1721.669a4.41,4.41,0,0,0-1.321-3.211,4.626,4.626,0,0,0-3.17-1.328h-72.4a4.627,4.627,0,0,0-3.171,1.328,4.41,4.41,0,0,0-1.321,3.211v52.652a4.407,4.407,0,0,0,1.321,3.2,4.63,4.63,0,0,0,3.171,1.328h72.4a4.629,4.629,0,0,0,3.17-1.328,4.407,4.407,0,0,0,1.321-3.2Z",
  transform: "translate(-2274.666 -1717.13)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_127",
  "data-name": "Caminho 127",
  d: "M2297.722,1836.525a5.216,5.216,0,0,1,5.214,5.214v3.678a5.216,5.216,0,0,1-5.214,5.214h-23.454v-14.106Z",
  transform: "translate(-2274.268 -1815.705)",
  fill: "#ebf0fd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_128",
  "data-name": "Caminho 128",
  d: "M2443.761,1972.314a.684.684,0,0,0-.684-.683h-14.254a.682.682,0,0,0-.676.683h0a.682.682,0,0,0,.676.683h14.254a.683.683,0,0,0,.684-.683Z",
  transform: "translate(-2401.313 -1927.25)",
  fill: "#e1e6f2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_229",
  "data-name": "Ret\\xE2ngulo 229",
  width: 3.772,
  height: 18.94,
  transform: "translate(37.142 18.209)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_230",
  "data-name": "Ret\\xE2ngulo 230",
  width: 3.772,
  height: 12.333,
  transform: "translate(45.001 24.815)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_231",
  "data-name": "Ret\\xE2ngulo 231",
  width: 3.772,
  height: 12.752,
  transform: "translate(52.858 18.208)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_124",
  "data-name": "Elipse 124",
  cx: 0.808,
  cy: 0.808,
  r: 0.808,
  transform: "translate(66.09 4.307)",
  fill: "#1e3084"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_125",
  "data-name": "Elipse 125",
  cx: 0.808,
  cy: 0.808,
  r: 0.808,
  transform: "translate(69.771 4.307)",
  fill: "#ffb000"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_126",
  "data-name": "Elipse 126",
  cx: 0.808,
  cy: 0.808,
  r: 0.808,
  transform: "translate(73.451 4.307)",
  fill: "#ffb000"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_232",
  "data-name": "Ret\\xE2ngulo 232",
  width: 3.772,
  height: 8.304,
  transform: "translate(60.715 22.657)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_129",
  "data-name": "Caminho 129",
  d: "M2438.835,1995.758a.684.684,0,0,0-.684-.683h-9.329a.682.682,0,0,0-.676.683h0a.682.682,0,0,0,.676.683h9.329a.684.684,0,0,0,.684-.683Z",
  transform: "translate(-2401.313 -1946.606)",
  fill: "#e1e6f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_130",
  "data-name": "Caminho 130",
  d: "M2438.835,2019.2a.684.684,0,0,0-.684-.683h-9.329a.682.682,0,0,0-.676.683h0a.682.682,0,0,0,.676.683h9.329a.684.684,0,0,0,.684-.683Z",
  transform: "translate(-2401.313 -1965.961)",
  fill: "#e1e6f2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3450",
  "data-name": "Grupo 3450",
  transform: "translate(27.139 24.184)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_127",
  "data-name": "Elipse 127",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(0 10.551)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_128",
  "data-name": "Elipse 128",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_129",
  "data-name": "Elipse 129",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(0 13.889)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_130",
  "data-name": "Elipse 130",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(0 3.338)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_131",
  "data-name": "Elipse 131",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(0 6.676)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_132",
  "data-name": "Elipse 132",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(3.798 10.551)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_133",
  "data-name": "Elipse 133",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(3.798)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_134",
  "data-name": "Elipse 134",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(3.798 13.889)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_135",
  "data-name": "Elipse 135",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(3.798 3.338)",
  fill: "#3d2f95"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_136",
  "data-name": "Elipse 136",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(3.798 6.676)",
  fill: "#3d2f95"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3451",
  "data-name": "Grupo 3451",
  transform: "translate(89.696 72.983)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_131",
  "data-name": "Caminho 131",
  d: "M2618.863,1914.562a5.189,5.189,0,0,0-5.182-5.2H2570.9a5.192,5.192,0,0,0-5.2,5.2v35.716a5.192,5.192,0,0,0,5.2,5.2h42.776a5.189,5.189,0,0,0,5.182-5.2Z",
  transform: "translate(-2565.705 -1909.366)",
  fill: "#45e5b6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_132",
  "data-name": "Caminho 132",
  d: "M2565.705,2111.42h53.158v5.677a5.189,5.189,0,0,1-5.182,5.2H2570.9a5.192,5.192,0,0,1-5.2-5.2Z",
  transform: "translate(-2565.705 -2076.185)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_133",
  "data-name": "Caminho 133",
  d: "M2646.74,2132.44a.684.684,0,0,0-.684-.684H2631.8a.682.682,0,0,0-.675.684h0a.682.682,0,0,0,.675.683h14.254a.684.684,0,0,0,.684-.683Z",
  transform: "translate(-2619.718 -2092.975)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_134",
  "data-name": "Caminho 134",
  d: "M2641.814,2147.88a.684.684,0,0,0-.684-.683H2631.8a.682.682,0,0,0-.675.683h0a.682.682,0,0,0,.675.683h9.329a.684.684,0,0,0,.684-.683Z",
  transform: "translate(-2619.718 -2105.723)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_135",
  "data-name": "Caminho 135",
  d: "M2573.065,1909.365h6.992q.052.647.053,1.31a13.849,13.849,0,0,1-13.843,13.844c-.193,0-.369,0-.562-.011v-6.933c.193.015.369.023.562.023a6.919,6.919,0,0,0,6.922-6.922A6.453,6.453,0,0,0,2573.065,1909.365Z",
  transform: "translate(-2565.705 -1909.365)",
  fill: "#1ac4a2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_136",
  "data-name": "Caminho 136",
  d: "M2634.252,1974.973l.263.2a.5.5,0,0,1,.036.318l-.07.146c-1.88,2.374-4.181,4.562-7.08,5.164-2.266.469-4.6-.2-6.886-.775a9.061,9.061,0,0,0-5.937.132c-2.266,1.036-3.795,3.158-5.551,5.026a24.848,24.848,0,0,1-5.323,4.728,4.131,4.131,0,0,1-2.829.61c-1.879-.364-3.162-2.245-5.006-2.393-2.635-.211-5.13,1.8-6.728,3.445l-.158.125-.334.009a.494.494,0,0,1-.229-.221.528.528,0,0,1,.123-.5c.193-.2.246-.248.369-.366a11.362,11.362,0,0,1,5.885-3.292,4.706,4.706,0,0,1,3.3.741c.158.107.316.215.457.322,1.089.751,2.266,1.565,3.513,1.289,1.581-.343,2.828-1.6,4.075-2.788,1.81-1.715,3.426-3.687,5.147-5.392a8.908,8.908,0,0,1,6.008-2.787c3.83-.036,7.519,2.5,11.419.779a13.886,13.886,0,0,0,5.094-4.377l.281-.157Z",
  transform: "translate(-2584.443 -1963.521)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3452",
  "data-name": "Grupo 3452",
  transform: "translate(12.794 57.923)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_137",
  "data-name": "Caminho 137",
  d: "M2176.867,1828.219a5.221,5.221,0,0,0-5.219-5.214h-41.715a5.209,5.209,0,0,0-5.219,5.214v3.677a5.209,5.209,0,0,0,5.219,5.215h41.715a5.221,5.221,0,0,0,5.219-5.215Z",
  transform: "translate(-2124.714 -1823.004)",
  fill: "#bbcdf7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_138",
  "data-name": "Caminho 138",
  d: "M2240.194,1857.137a1.334,1.334,0,0,0-1.335-1.333h-27.809a1.33,1.33,0,0,0-1.318,1.333h0a1.33,1.33,0,0,0,1.318,1.333h27.809a1.334,1.334,0,0,0,1.335-1.333Z",
  transform: "translate(-2194.907 -1850.084)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_137",
  "data-name": "Elipse 137",
  cx: 2.262,
  cy: 2.262,
  r: 2.262,
  transform: "translate(7.394 4.791)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3453",
  "data-name": "Grupo 3453",
  transform: "translate(37.049)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_139",
  "data-name": "Caminho 139",
  d: "M2427.734,1674.618s-2.284.289-2.477.248a16.369,16.369,0,0,1-2.319-2.278c-.228-.378-.562-1.536-1.88-1.452,0,0,2.512,7.763,2.635,8.141l5.464-.154Z",
  transform: "translate(-2393.636 -1639.693)",
  fill: "#de6830"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_140",
  "data-name": "Caminho 140",
  d: "M2453.745,1675.833a3.5,3.5,0,0,1-2.354-2.933c-.351-1.957,1.651-2.356,3.109-2.747a121.986,121.986,0,0,1,20.431-3.03c8.432-.289-8.977,8.693-11.173,8.725S2453.745,1675.833,2453.745,1675.833Z",
  transform: "translate(-2418.646 -1636.377)",
  fill: "#2d216e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_141",
  "data-name": "Caminho 141",
  d: "M2475.019,1667.142c-3.145.73-6.324,1.978-10.259,3.059-4.743,1.3-6.605,1.03-7.818,1.348-.843.22-3.812,1.015-5.534,1.479,0-.035-.017-.07-.017-.106-.351-1.957,1.651-2.356,3.109-2.747a122,122,0,0,1,20.431-3.03Z",
  transform: "translate(-2418.646 -1636.399)",
  fill: "#453696"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_142",
  "data-name": "Caminho 142",
  d: "M2461.419,1669.019a2.537,2.537,0,0,1,.123,2.146c-.491,1.089-1.23,3.6-7.571,4.266s-6.834.327-8.608,1.813c-1.757,1.486-6.8,5.228-10.294,8.228a39.139,39.139,0,0,1-3.443,2.853s-7.747,1.486-8.871,1.472c0,0-.246-3.444,3.25-3.264,0,0,7.87-7.941,12.4-12.485,4.55-4.544,5.656-5.493,12.666-6.369,6.992-.875,8.7-.931,8.7-.931Z",
  transform: "translate(-2395.033 -1636.073)",
  fill: "#2d216e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_143",
  "data-name": "Caminho 143",
  d: "M2494.666,1668.763c.386,1.221-1.476,2.413-6.131,3.629-6.008,1.564-5.2,1.731-10.681,7.25-3.988,3.992-6.921,3.932-8.239,3.594,2.459-2.469,5.341-5.376,7.484-7.525,4.55-4.544,5.656-5.493,12.666-6.369C2491.82,1669.085,2493.418,1668.9,2494.666,1668.763Z",
  transform: "translate(-2433.725 -1637.737)",
  fill: "#453696"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_144",
  "data-name": "Caminho 144",
  d: "M2429.307,1761.063a4.846,4.846,0,0,0,4.831,3.062,23.8,23.8,0,0,1-2.512,2.068s-7.747,1.486-8.871,1.472c0,0-.246-3.444,3.25-3.264C2426,1764.4,2427.374,1763.012,2429.307,1761.063Z",
  transform: "translate(-2395.033 -1713.942)",
  fill: "#de6830"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_145",
  "data-name": "Caminho 145",
  d: "M2573.973,1593.094l.3-.554c1.687-3.418,2.284-5.136,5.586-5.815,3.285-.679,8.485.516,7.695,5.857,0,0-.123,7.709-2.565,12.372,0,0-2.793-2.786-3.215-4.134-.439-1.348-9.082.1-9.082.1l-.421.019a5.877,5.877,0,0,0,.7-1.422s1.6-3.738,2.319-5.738Z",
  transform: "translate(-2518.478 -1569.862)",
  fill: "#b84816"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_146",
  "data-name": "Caminho 146",
  d: "M2589.675,1588.658c.263.753,1.476,1.578,4.479,1.016a11.88,11.88,0,0,0,1.792-.482,4.656,4.656,0,0,1,2.214,5.129,1.657,1.657,0,0,1-.018.2,15.915,15.915,0,0,1-2.108,4.876c-.773,1.362-1.651,1.405-1.651,1.405s-4.62-1.61-2.934-3.65a14.7,14.7,0,0,0,2.442-4.674c-.527.767-3.039,2.567-6.219,4.242-1.985,1.052-2.635,1.368-2.547.791.3-.724.563-1.433.773-2,.72-1.725.017-2.1-.58-2.152C2586.566,1590.809,2587.321,1589.364,2589.675,1588.658Z",
  transform: "translate(-2529.086 -1571.601)",
  fill: "#f45700"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_147",
  "data-name": "Caminho 147",
  d: "M2633.95,1604.334a5.6,5.6,0,0,1,.262,2.926v.2a15.877,15.877,0,0,1-2.128,4.877c-.767,1.362-1.657,1.4-1.657,1.4a10.814,10.814,0,0,1-1.517-.7c-.4-.872.488-2.07.488-2.07A37.075,37.075,0,0,0,2633.95,1604.334Z",
  transform: "translate(-2565.156 -1584.543)",
  fill: "#cd5a24"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_148",
  "data-name": "Caminho 148",
  d: "M2547.191,1624.067l1.317.68c-.72,2-2.319,5.738-2.319,5.738a5.875,5.875,0,0,1-.7,1.422l-5.657.251,3.882-4.17A9.621,9.621,0,0,0,2547.191,1624.067Z",
  transform: "translate(-2491.696 -1600.835)",
  fill: "#ff9e62"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_149",
  "data-name": "Caminho 149",
  d: "M2576.793,1637.324a48.993,48.993,0,0,1,4.514,2.275,9.49,9.49,0,0,1-6.008,4.476c-4.954,1.419-7.729.559-7.905-1.44-.193-2,3.145-2.243,5.639-3.151A11.048,11.048,0,0,0,2576.793,1637.324Z",
  transform: "translate(-2514.447 -1611.781)",
  fill: "#db773e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_150",
  "data-name": "Caminho 150",
  d: "M2568.044,1643.929a1.938,1.938,0,0,1-.65-1.293c-.193-2,3.145-2.243,5.639-3.151a11.048,11.048,0,0,0,3.76-2.161s.9.4,1.9.889a7.521,7.521,0,0,1-4.655,3.4C2570.661,1642.552,2569.1,1642.7,2568.044,1643.929Z",
  transform: "translate(-2514.447 -1611.781)",
  fill: "#ff9e62"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_151",
  "data-name": "Caminho 151",
  d: "M2588.039,1545.633a3.649,3.649,0,0,0,2.9-.19s.158,1.394.668,1.811a.832.832,0,0,1,1.159-.093.961.961,0,0,1-.3,1.615s.492,1.312,1.406,1.519a2.762,2.762,0,0,0,.509,2.427c-2.635,3.032-4.831,1.553-4.831,1.553a16.666,16.666,0,0,0,.369-2.452c-1.774.293-3.988.245-3.725-2.2a9.953,9.953,0,0,1,1.617-4.1Z",
  transform: "translate(-2529.957 -1535.922)",
  fill: "#ff9e62"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_152",
  "data-name": "Caminho 152",
  d: "M2610.064,1564.539c.018.077.523,1.315,1.413,1.513a2.777,2.777,0,0,0,.506,2.427,6.254,6.254,0,0,1-1.709,1.435c0-.009-.018-3.4-.889-3.057s-1.884.724-1.884.724l2.563-3.048Z",
  transform: "translate(-2547.566 -1551.684)",
  fill: "#db773e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_153",
  "data-name": "Caminho 153",
  d: "M2592.136,1529.724a2.018,2.018,0,0,1-.65-2.226c.51-2.384,2.67-.525,3.742-.149a4.155,4.155,0,0,1,3.83,1.538c.843,1.414.527,2.785-.457,4.591a3.473,3.473,0,0,0-.4,1.016c-.914-.206-1.406-1.519-1.406-1.519a.961.961,0,0,0,.3-1.615.832.832,0,0,0-1.159.093c-.51-.417-.668-1.811-.668-1.811A3.446,3.446,0,0,1,2592.136,1529.724Z",
  transform: "translate(-2534.283 -1520.121)",
  fill: "#0e0057"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_154",
  "data-name": "Caminho 154",
  d: "M2575.2,1676.886l-4.989-.442v.55l4.989.441Z",
  transform: "translate(-2516.782 -1644.079)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_155",
  "data-name": "Caminho 155",
  d: "M2312.15,1555.955s-.439-4.856-6.113-8.552c-5.692-3.7-8.485-.049-10.4,2.46s-2.02,3.819-6.957-.647c-4.954-4.467-8.5-8.821-16.039-6.54-7.519,2.281-8.836,10.912-8.836,10.912s10.382,6.355,13.07,7.313c0,0,2.336-6.969,8.749-8.742a6.214,6.214,0,0,0,.9,2.021c.545.623,6.851,2.424,10.241,2.52s5.025-.848,6.535-3.544a4.172,4.172,0,0,1,1.616,2.275Z",
  transform: "translate(-2263.805 -1533.12)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_156",
  "data-name": "Caminho 156",
  d: "M2388.924,1599.229s4.708-1.512,11.137,4.541c-3.39-.1-9.7-1.9-10.242-2.52a5.892,5.892,0,0,1-.878-2.005Z",
  transform: "translate(-2367.105 -1580.19)",
  fill: "#8fa0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_157",
  "data-name": "Caminho 157",
  d: "M2490.367,1593.7a4.1,4.1,0,0,1,3.443-2.527,5.272,5.272,0,0,1,4.04,1.623,9.818,9.818,0,0,1,1.353,3.7l-7.238-.525A4.282,4.282,0,0,0,2490.367,1593.7Z",
  transform: "translate(-2450.858 -1573.662)",
  fill: "#8fa0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_158",
  "data-name": "Caminho 158",
  d: "M2495.242,1616.773s6.535.789,8.766,1.219c.755.213,1,.3,1.335,1.7s1.915,7.278,2.354,8.089c0,0-9.644-.771-11.3-1.056-1.247-.147-2.038-3.194-2.653-5.96C2493.151,1618,2492.729,1616.43,2495.242,1616.773Z",
  transform: "translate(-2453.273 -1594.775)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_159",
  "data-name": "Caminho 159",
  d: "M2523.466,1641.782c.017.047.017.094.035.142a1.248,1.248,0,0,1-1.212,1.518,1.808,1.808,0,0,1-1.7-1.518,1.232,1.232,0,0,1,1.212-1.518,1.6,1.6,0,0,1,.422.059.876.876,0,0,0-.3.674v.026a.632.632,0,0,0-.615.759.921.921,0,0,0,.861.759.612.612,0,0,0,.615-.634h.036A.887.887,0,0,0,2523.466,1641.782Z",
  transform: "translate(-2475.788 -1614.326)",
  fill: "#6e6e6e"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_138",
  "data-name": "Elipse 138",
  cx: 0.456,
  cy: 0.456,
  r: 0.456,
  transform: "translate(46.577 26.358)",
  fill: "#6e6e6e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_160",
  "data-name": "Caminho 160",
  d: "M2485.59,1490.845a29.225,29.225,0,0,1,4.658,1.805,9.832,9.832,0,0,0,.37,1.552s-2.839,4.911-3.135,5.571a20.094,20.094,0,0,0-3.061-.784,8.385,8.385,0,0,1-3.091-.939A16.912,16.912,0,0,1,2485.59,1490.845Z",
  transform: "translate(-2443.398 -1490.845)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_161",
  "data-name": "Caminho 161",
  d: "M2506.486,1499.754a.411.411,0,0,1,.052.014,17.281,17.281,0,0,1,2.128.825,2.561,2.561,0,0,1,.4.239s.087.094.035.176c-.087.164-.4-.1-.7-.237a19.5,19.5,0,0,0-1.97-.753.158.158,0,0,1-.07-.054A.133.133,0,0,1,2506.486,1499.754Z",
  transform: "translate(-2464.046 -1498.2)",
  fill: "#b3c1e4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_162",
  "data-name": "Caminho 162",
  d: "M2502.619,1506.169a.373.373,0,0,1,.122.04c.593.2,1.168.4,1.727.645a.174.174,0,0,1,.07.122.136.136,0,0,1-.174.129c-.1-.038-.1-.045-.157-.066-.541-.225-1.081-.424-1.639-.607a.164.164,0,0,1-.07-.044A.135.135,0,0,1,2502.619,1506.169Z",
  transform: "translate(-2460.847 -1503.497)",
  fill: "#b3c1e4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_163",
  "data-name": "Caminho 163",
  d: "M2397.258,1511.626s1.528,1.936,3.074,1.881c0,0,2.3,3.331,2.336,4.769,0,0-4.725-1.171-6.342-1.7,0,0-.088-.937-2.372-3a11.624,11.624,0,0,1-2.916-3.593A56.281,56.281,0,0,1,2397.258,1511.626Z",
  transform: "translate(-2368.852 -1506.645)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3454",
  "data-name": "Grupo 3454",
  transform: "translate(48.103 27.685)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_164",
  "data-name": "Caminho 164",
  d: "M2329.879,1656.249h0s-2.284-2.595-1.915-4.467,2.2.382,2.846,2.314c0,0-.194-4.164,1.44-4.48s.791,4.619.791,4.619,2.372-1.556.527,1.973A25.088,25.088,0,0,0,2329.879,1656.249Z",
  transform: "translate(-2327.796 -1649.603)",
  fill: "#1cb047"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_165",
  "data-name": "Caminho 165",
  d: "M2328.433,1690.707c-.668-1.045-1.9-3.462-.808-5.578h6.429c1.089,2.116-.14,4.533-.808,5.578Z",
  transform: "translate(-2327.192 -1678.934)",
  fill: "#190070"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3455",
  "data-name": "Grupo 3455",
  transform: "translate(23.319 78.205)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_166",
  "data-name": "Caminho 166",
  d: "M2249.571,2042.016s-4.9-1.861-8.867-.719c-3.737,1.076-7.137,6.129-8.9,8.838-1.992,3.051-.255,6.962.349,8,.586,1.045,10.414,10.252,14.185,10.247s8.052-1.152,10.447-5.816c2.165-4.209,2.145-12.042.847-15.2-.991-2.412-3.242-3.812-5.784-4.588A9.5,9.5,0,0,0,2249.571,2042.016Z",
  transform: "translate(-2222.889 -2023.206)",
  fill: "#29c18f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_167",
  "data-name": "Caminho 167",
  d: "M2234.463,2050.678c.1-.176.192-.349.314-.52,1.761-2.712,5.162-7.764,8.894-8.838,3.958-1.142,8.876.719,8.876.719a7.175,7.175,0,0,1,2.093.713c-1.622.209-1.744.792-1.744.792a7.9,7.9,0,0,0,4.028,1.723c1.064.2,1.552-.119,1.6-.588a6.634,6.634,0,0,1,2.075,2.715c1.221,3,1.308,10.229-.541,14.551a17.127,17.127,0,0,0-.192-1.929c-.279-1.765.628-4.471-.035-5.149a21.67,21.67,0,0,1-1.883-2.755l-.89,2.4s-14.456-5.708-14.16-6.207c.279-.5.907-2.131.907-2.131s-1.308.4-2.79.689c-1.464.29-1.186,1.276-3.435,3.495C2235.98,2051.936,2234.934,2051.221,2234.463,2050.678Z",
  transform: "translate(-2225.849 -2023.226)",
  fill: "#45e5b6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_168",
  "data-name": "Caminho 168",
  d: "M2241.673,2145.059s.962-2,6.325-.55,12.544,6.352,12.014,7.789C2259.465,2153.737,2240.094,2150.512,2241.673,2145.059Z",
  transform: "translate(-2231.726 -2108.289)",
  fill: "#132162"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_169",
  "data-name": "Caminho 169",
  d: "M2247.367,2088.64a46.8,46.8,0,0,1,3.731-12.2s15.231,5.523,19.574,7.877c0,0-2.55,7.3-5.45,11.554C2265.09,2096.055,2247.367,2088.64,2247.367,2088.64Z",
  transform: "translate(-2236.503 -2052.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_170",
  "data-name": "Caminho 170",
  d: "M2248.227,2122.214c1.658.716,5.977,2.247,10.1.838,1.992-.872,2.065-1.173,3.165-.76,1.037.38,5.9,2.217,8.864.6a56.1,56.1,0,0,1-5.131,10.684c-.133.185-17.855-7.23-17.855-7.23A39.727,39.727,0,0,1,2248.227,2122.214Z",
  transform: "translate(-2236.503 -2090.232)",
  fill: "#e2e5fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_171",
  "data-name": "Caminho 171",
  d: "M2300.4,2184.408s9.086-.3,11.705-.2a4.685,4.685,0,0,1,4.409,5.282c-.449,2.656-3.229,4.678-8.189,3.987C2303.381,2192.782,2300.4,2184.408,2300.4,2184.408Z",
  transform: "translate(-2280.286 -2141.487)",
  fill: "#132162"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_172",
  "data-name": "Caminho 172",
  d: "M2316.364,2184.354c2.895-.079,7.237-.178,8.928-.117a4.8,4.8,0,0,1,3.993,2.63c-1.813,1.777-6.522,1.134-8.37.644C2319.416,2187.11,2317.323,2185.251,2316.364,2184.354Z",
  transform: "translate(-2293.468 -2141.511)",
  fill: "#1e3084"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_173",
  "data-name": "Caminho 173",
  d: "M2218.314,2181.134s-.84,3.644,5.11,3.569C2229.392,2184.625,2218.314,2181.134,2218.314,2181.134Z",
  transform: "translate(-2212.483 -2138.965)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_174",
  "data-name": "Caminho 174",
  d: "M2204.017,2136.934l-.532-.261c-1.364-.732-14.237-7.26-16.186-8.929-1.966-1.667-3.611-6.178-.493-8.77,3.1-2.589,6.9,1.245,9.616,3.522s11.1,7.79,10.8,9.83A16.3,16.3,0,0,1,2204.017,2136.934Z",
  transform: "translate(-2185.066 -2086.93)",
  fill: "#132162"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_175",
  "data-name": "Caminho 175",
  d: "M2201.274,2118.215c2.773-.638,5.824,2.384,8.109,4.3,2.7,2.272,11.091,7.79,10.794,9.83a21.535,21.535,0,0,1-1.082,1.96,19.438,19.438,0,0,1-6.8-5.267c-1.5-2.162-7.934-4.632-10.515-7.085A2.716,2.716,0,0,1,2201.274,2118.215Z",
  transform: "translate(-2198.013 -2086.946)",
  fill: "#1e3084"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_176",
  "data-name": "Caminho 176",
  d: "M2300.6,2201.9c.716.451,1.6-.457,3.16,1.691s1.53,4.687-1.234,3.921a75.248,75.248,0,0,1-8.788-3.267,16.309,16.309,0,0,0,3.2-4.61Z",
  transform: "translate(-2274.787 -2154.237)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_177",
  "data-name": "Caminho 177",
  d: "M2323.278,1986.9s-2.282,5.265-.44,6.568a4.088,4.088,0,0,1-1.143,1.831,4.476,4.476,0,0,0,6.092,1.867,8.9,8.9,0,0,1,.094-2.567s1-.309,1.763-2.293c.779-1.988,1.928-4.38-.353-6.139S2323.859,1985.531,2323.278,1986.9Z",
  transform: "translate(-2297.869 -1977.249)",
  fill: "#bc6d1e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_178",
  "data-name": "Caminho 178",
  d: "M2337.926,2041.386a3.69,3.69,0,0,1-.174-3.128,6.631,6.631,0,0,0,3.174.106,8.769,8.769,0,0,0-.087,2.555A5.207,5.207,0,0,1,2337.926,2041.386Z",
  transform: "translate(-2310.915 -2021.003)",
  fill: "#994936"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_179",
  "data-name": "Caminho 179",
  d: "M2320.879,2001.9s-1.2-.749-1.789.334c-.566,1.08.49,2.51,1.146,2.011S2320.879,2001.9,2320.879,2001.9Z",
  transform: "translate(-2295.585 -1990.781)",
  fill: "#994936"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_180",
  "data-name": "Caminho 180",
  d: "M2365.476,2013.8s1.612.159,1.476,1.309c-.184,1.518-1.736,1.629-2.041.914S2365.476,2013.8,2365.476,2013.8Z",
  transform: "translate(-2333.496 -2000.814)",
  fill: "#994936"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_181",
  "data-name": "Caminho 181",
  d: "M2345.046,2016.119a.471.471,0,0,1-.19-.222.518.518,0,0,1-.021-.406c.2-.531.488-1.363.684-1.9a.606.606,0,0,1,.293-.317.549.549,0,0,1,.424-.019h0a.554.554,0,0,1,.314.289.57.57,0,0,1,.025.427c-.2.54-.5,1.375-.684,1.9a.569.569,0,0,1-.278.3.56.56,0,0,1-.2.05,5.6,5.6,0,0,1-.976,1.828,2.321,2.321,0,0,1-2.029.673c-.211-.037-.423-.077-.635-.116-.233.245-.809.047-1.31-.05-.311-.075-.381-.646.014-.717.308-.046,1.236.05,1.378.415a3.463,3.463,0,0,0,1.21.114,1.884,1.884,0,0,0,1.434-1.074C2344.691,2016.9,2344.877,2016.51,2345.046,2016.119Z",
  transform: "translate(-2313.155 -2000.332)",
  fill: "#ff0024"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_182",
  "data-name": "Caminho 182",
  d: "M2360.144,1988.739a3.337,3.337,0,0,1,.427.294c1.952,1.493,1.39,3.45.719,5.221a1.076,1.076,0,0,1-.562-.816c-.067-.655-.173-1.814-.173-1.814a4.7,4.7,0,0,1-.973-1.426A2.66,2.66,0,0,1,2360.144,1988.739Z",
  transform: "translate(-2329.149 -1980.12)",
  fill: "#00010a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_183",
  "data-name": "Caminho 183",
  d: "M2325.96,1983.426s.9.162,1.246-.49c.36-.656.64-1.143.64-1.143s3.592.923,4.98-.687c1.406-1.614.908-3.677-1.812-2.824s-3.532,1.478-4.191,2.52A7.875,7.875,0,0,0,2325.96,1983.426Z",
  transform: "translate(-2301.39 -1971.321)",
  fill: "#00010a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_184",
  "data-name": "Caminho 184",
  d: "M2200.379,1964.767s3.026-2.886,1.5-6.547c-1.5-3.663-6.607-3.326-10.273-1.572-3.684,1.757-5.389,6.035-2.739,8.875,2.669,2.837,8.059.867,8.059.867s3.641-.1,4.3.46A15.314,15.314,0,0,0,2200.379,1964.767Z",
  transform: "translate(-2187.145 -1952.575)",
  fill: "#fee602"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_185",
  "data-name": "Caminho 185",
  d: "M2237.29,1947.818s-2.845-3.281,2.146-6.489c4.973-3.2,10.155-2.62,10.236,1.971.1,4.588-5.872,6.334-9.733,6.158a13.4,13.4,0,0,1-1.706,1.009A8.387,8.387,0,0,1,2237.29,1947.818Z",
  transform: "translate(-2227.516 -1939.313)",
  fill: "#1ada9a"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_139",
  "data-name": "Elipse 139",
  cx: 0.508,
  cy: 0.508,
  r: 0.508,
  transform: "translate(12.496 5.76) rotate(-10.623)",
  fill: "#1e3084"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_140",
  "data-name": "Elipse 140",
  cx: 0.508,
  cy: 0.508,
  r: 0.508,
  transform: "translate(3.567 9.469) rotate(-10.623)",
  fill: "#ce7231"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_141",
  "data-name": "Elipse 141",
  cx: 0.508,
  cy: 0.508,
  r: 0.508,
  transform: "matrix(0.983, -0.184, 0.184, 0.983, 15.098, 4.936)",
  fill: "#1e3084"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_142",
  "data-name": "Elipse 142",
  cx: 0.508,
  cy: 0.508,
  r: 0.508,
  transform: "translate(6.169 8.645) rotate(-10.623)",
  fill: "#ce7231"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_143",
  "data-name": "Elipse 143",
  cx: 0.508,
  cy: 0.508,
  r: 0.508,
  transform: "translate(17.7 4.111) rotate(-10.623)",
  fill: "#1e3084"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3456",
  "data-name": "Grupo 3456",
  transform: "translate(110.515 88.928)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_186",
  "data-name": "Caminho 186",
  d: "M2870.541,2079.8a8.2,8.2,0,0,0,3.162,1.44c1.159,0,4.5-2.524,4.5-2.524s-1.37,5.613-2.354,6.123a8.975,8.975,0,0,1-5.305-.1Z",
  transform: "translate(-2838.202 -2065.134)",
  fill: "#dbd6f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_187",
  "data-name": "Caminho 187",
  d: "M2870.567,2089.689v-4.754a9.212,9.212,0,0,0,2.913,1.421h0c-.1,2.368,1.1,3.015,1.1,3.015A8.756,8.756,0,0,1,2870.567,2089.689Z",
  transform: "translate(-2838.223 -2070.264)",
  fill: "#ea8853"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_188",
  "data-name": "Caminho 188",
  d: "M2736.792,2154.551l.633-.292c1.581-.8,4.181-2.157,6.57-3.415s12.473-6.767,12.473-6.767l15.547,1.7-5.288,1.7-27.827,12.8-.579-1.325Z",
  transform: "translate(-2727.776 -2119.093)",
  fill: "#b84816"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_189",
  "data-name": "Caminho 189",
  d: "M2757.483,2144.188a2.767,2.767,0,0,1-.61,2.609c-.872.569-3.61,1.48-5.231,2.49-1.639,1.01-1.639,2.263-7.2,5.338a18.852,18.852,0,0,1-6.766,2.443l-.872-2.518.61-.291c1.587-.8,4.185-2.157,6.574-3.415,2.406-1.259,12.486-6.768,12.486-6.768Z",
  transform: "translate(-2727.784 -2119.092)",
  fill: "#f45700"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_190",
  "data-name": "Caminho 190",
  d: "M2694.107,2190.735l1.528,4.4-4.813,2.174s-4.989-7.749-5.6-8.947,1.142.245,2.354,1.122c1.195.876,3.285,2.487,3.689,2.384A20.1,20.1,0,0,0,2694.107,2190.735Z",
  transform: "translate(-2685.092 -2155.276)",
  fill: "#3e3e3e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_191",
  "data-name": "Caminho 191",
  d: "M2916.672,2011.781s-1.38-1.253-1.365-2.225,1.334-1.772,1.132-3.815c-.217-2.043-1.923-2.539-2.761-3.212s-1.676-2.036-2.808-1.661-2.063,1.272-.962,2.186a10.214,10.214,0,0,0-1.893,4.384c-.465,2.661.031,3.646,1.908,3.527,1.939-.125,1.955.139,2.3,1.445S2916.672,2011.781,2916.672,2011.781Z",
  transform: "translate(-2869.008 -2000.804)",
  fill: "#ffa473"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_192",
  "data-name": "Caminho 192",
  d: "M2915.8,2043.822a5.566,5.566,0,0,0,2.284-2.033,2.61,2.61,0,0,1,1.5-1.036,2.692,2.692,0,0,1,2.616.7,2.253,2.253,0,0,0-.349.97c-.017.865,1.082,1.951,1.308,2.181a.578.578,0,0,1-.1.113,16.4,16.4,0,0,1-1.883.718c-.959.11-1.848-.026-1.813-.221.069-.427.732-1.955-1.36-1.564-.314.063-.627.111-.889.153-.191,0-.4.011-.627.026A3.734,3.734,0,0,1,2915.8,2043.822Z",
  transform: "translate(-2875.569 -2033.675)",
  fill: "#ea8853"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_193",
  "data-name": "Caminho 193",
  d: "M2797.159,2152.449a5.208,5.208,0,0,1-1.458-.941c-.263-.393.105-.586.4-1.044s3.812-8.019,4.585-9.594c.755-1.574,2.758-6,3.794-6.971s3.373-1.536,5.13-1.7,7.483-.419,7.483-.419l6.113,6.621-.369,1.016a17.255,17.255,0,0,1-6.429.774c-3.742-.224-7.466-.279-7.466-.279s-3.953,7.387-4.708,8.711c-.772,1.324-.772,1.954-1.634,3.427-.387.673-.79,1.434-1.177,2.217-.492-.235-1.3-.583-2.073-.911Z",
  transform: "translate(-2776.338 -2108.941)",
  fill: "#b84816"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_194",
  "data-name": "Caminho 194",
  d: "M2767.275,2251.208c.773.326,1.581.669,2.073.912-.475.932-.931,1.9-1.388,2.79a7.223,7.223,0,0,1-1.089,1.82s-3.742-.377-5.9-.576a39.683,39.683,0,0,1-4.163-.533c-.316-.1.9-.762,2.863-1.2a27.919,27.919,0,0,0,3.847-1.207,25.915,25.915,0,0,0,1.564-2.914Z",
  transform: "translate(-2744.258 -2206.793)",
  fill: "#3e3e3e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_195",
  "data-name": "Caminho 195",
  d: "M2814.894,2132.346c2.912,1.228,2.371,3.878-1.482,4.175-3.959.3-5.232.273-6.557,2.241-1.308,1.965-3.61,6.185-6.452,10.744-1.779,2.846-3.488,3.02-4.516,2.75a1.785,1.785,0,0,1-.3-.281c-.261-.392.122-.586.419-1.044s3.8-8.018,4.569-9.593,2.773-6,3.8-6.972c1.046-.975,3.366-1.534,5.127-1.7C2810.569,2132.567,2813.08,2132.435,2814.894,2132.346Z",
  transform: "translate(-2776.249 -2109.407)",
  fill: "#f45700"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_196",
  "data-name": "Caminho 196",
  d: "M2818.831,2070.737s-.843,1.346-1.23,2.066-.439,1.452.667,2.393c1.089.941,3.215,3.93,6.324,4.484,0,0,2.829-.9,3.76-5.2a23.464,23.464,0,0,0-.474-10.736c-.615-2.287-1.651-4.167-3.356-4.287a6.711,6.711,0,0,0-6.271,2.547c-2,2.587-4.181,6.105-5.534,6.181s-6.307-2.241-7.29-2.646c-1-.406-1.95-2.217-4.515-1.965s-3.215,1.831-3.18,2.558c.053.728,2.653-.008,3.057.312a21.151,21.151,0,0,1,1.827,1.5c.351.4,3.654,4.075,7.361,5.159,3.724,1.083,5.446.588,6.078.229A19.916,19.916,0,0,0,2818.831,2070.737Z",
  transform: "translate(-2778.089 -2049.203)",
  fill: "#dbd6f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_197",
  "data-name": "Caminho 197",
  d: "M2895.763,2059.5c-.4.76-2.458,2.135-3.26,3.237-1.675,2.347-2.721,6.287-4.883,7.53-1.273.738-1.692-1.01-1.918-2.117,1.36-.591,3.331-3.725,5.162-6.084A6.346,6.346,0,0,1,2895.763,2059.5Z",
  transform: "translate(-2850.719 -2049.268)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_198",
  "data-name": "Caminho 198",
  d: "M2815.152,2093.168a10.929,10.929,0,0,1-5.214-.535c-3.714-1.085-7.01-4.756-7.359-5.16a21.487,21.487,0,0,0-1.831-1.5c-.4-.319-3.017.415-3.052-.312a1.505,1.505,0,0,1,.021-.307c.134-.793.909-2.031,3.153-2.251,2.563-.251,3.522,1.559,4.517,1.965s5.929,2.72,7.289,2.645a1.076,1.076,0,0,0,.372-.1,2.528,2.528,0,0,0,.466-.277,8.923,8.923,0,0,0,.157,2.722A10.067,10.067,0,0,0,2815.152,2093.168Z",
  transform: "translate(-2778.059 -2068.733)",
  fill: "#ea8853"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_199",
  "data-name": "Caminho 199",
  d: "M2797.8,2085.355c.139-.793.924-2.033,3.156-2.253,2.563-.251,3.523,1.559,4.517,1.965s5.929,2.72,7.289,2.645a1.014,1.014,0,0,0,.349-.091.774.774,0,0,1-.035.351c-1.046,2.678-4.43,2.051-7.516.31-3.1-1.74-3.732-3.386-5.72-3.036A5.43,5.43,0,0,1,2797.8,2085.355Z",
  transform: "translate(-2778.147 -2068.731)",
  fill: "#ffa473"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_200",
  "data-name": "Caminho 200",
  d: "M2911.66,2095.537a35.394,35.394,0,0,0,3.766-6.072,3.229,3.229,0,0,1,.523,3.216c-.785,1.664-1.22,2.112-1.046,3.313s.244,3.259-.733,4.387-1.656.8-2.371.29a.244.244,0,0,1-.07-.045,8.349,8.349,0,0,0-.645-.628c-1.1-.942-1.046-1.674-.663-2.394.332-.629,1.029-1.739,1.2-2.007Z",
  transform: "translate(-2870.922 -2074.004)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_201",
  "data-name": "Caminho 201",
  d: "M2813.111,2087.975c-1.055,2.68-4.427,2.051-7.519.31s-3.743-3.385-5.727-3.036a5.339,5.339,0,0,1-2.043.106c.134-.793.908-2.031,3.152-2.251,2.563-.251,3.523,1.559,4.517,1.965s5.929,2.72,7.29,2.645a1.075,1.075,0,0,0,.371-.1A.757.757,0,0,1,2813.111,2087.975Z",
  transform: "translate(-2778.163 -2068.733)",
  fill: "#ffa473"
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_202",
  "data-name": "Caminho 202",
  d: "M2719.125,1779.627a4.645,4.645,0,1,0,4.639,4.644A4.655,4.655,0,0,0,2719.125,1779.627Zm0,6.967a2.322,2.322,0,1,1,2.319-2.323A2.335,2.335,0,0,1,2719.125,1786.594Z",
  transform: "translate(-2598.833 -1729.268)",
  fill: "#f57900"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_203",
  "data-name": "Caminho 203",
  d: "M2249.588,1756.53a4.64,4.64,0,0,0,7.923-3.285,4.681,4.681,0,0,0-1.353-3.285l-1.651,1.642a2.319,2.319,0,0,1-1.633,3.965,2.351,2.351,0,0,1-1.651-.68Z",
  transform: "translate(-2215.018 -1704.776)",
  fill: "#fee602"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3457",
  "data-name": "Grupo 3457",
  transform: "translate(135.854 69.144)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_144",
  "data-name": "Elipse 144",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_145",
  "data-name": "Elipse 145",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  transform: "translate(0 4.961)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_146",
  "data-name": "Elipse 146",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  transform: "translate(5.223)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_147",
  "data-name": "Elipse 147",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  transform: "translate(5.223 4.961)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_148",
  "data-name": "Elipse 148",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  transform: "translate(10.446)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_149",
  "data-name": "Elipse 149",
  cx: 1.078,
  cy: 1.078,
  r: 1.078,
  transform: "translate(10.446 4.961)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3463",
  "data-name": "Grupo 3463",
  transform: "translate(130.132 18.434)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_150",
  "data-name": "Elipse 150",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  transform: "translate(3.175)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3458",
  "data-name": "Grupo 3458"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_151",
  "data-name": "Elipse 151",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3459",
  "data-name": "Grupo 3459",
  transform: "translate(3.175 3.343)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_152",
  "data-name": "Elipse 152",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3460",
  "data-name": "Grupo 3460",
  transform: "translate(0 3.343)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_153",
  "data-name": "Elipse 153",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3461",
  "data-name": "Grupo 3461",
  transform: "translate(3.175 6.687)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_154",
  "data-name": "Elipse 154",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3462",
  "data-name": "Grupo 3462",
  transform: "translate(0 6.687)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_155",
  "data-name": "Elipse 155",
  cx: 0.69,
  cy: 0.69,
  r: 0.69,
  fill: "#fff"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_204",
  "data-name": "Caminho 204",
  d: "M2952.853,1977.949s1.166-3.179,5.6-3.289,5.048,3.083,4.591,6.937-1.01,6.24.6,7.3a4.472,4.472,0,0,1-5.672-.219c-2.812-2.46-2.728-7.342-2.728-7.342Z",
  transform: "translate(-744.301 -399.444)",
  fill: "#001e86"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_205",
  "data-name": "Caminho 205",
  d: "M2914.546,1997.694c.9-4.534,6.394-4.466,7.728-1.495s.108,4.731,0,6.479a1.962,1.962,0,0,0-.012.263,1.706,1.706,0,0,1-1.514-.189c.553-1,.577-2.779-.541-2.814a1.137,1.137,0,0,0-1.262.9l-.409-.588a2.56,2.56,0,0,0-2.416-1.268c-1.586-.082-1.586-1.233-1.586-1.233Z",
  transform: "translate(-712.663 -415.501)",
  fill: "#001e86"
}));

var SvgReactive = function SvgReactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174.657,
    height: 138.864,
    viewBox: "0 0 174.657 138.864",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Reactive.1d0f5f93.svg";
export { ForwardRef as ReactComponent };